import { axiosInstance } from '@/modules/shared/lib/axios';
import { UserMutationResponse, UserMutationPayload } from './types';

type Props = {
  companyId: string
  userIdToUpdate: string
  payload: UserMutationPayload
}

export function updateAdminUser ({ companyId, userIdToUpdate, payload }: Props) {
    const body = {
        roles: payload.role ? [{ id: parseInt(payload.role.id, 10) }] : [],
        driverEntityId: payload.driverId ?? null,
    }
    return axiosInstance.post<UserMutationResponse>(`/config-api/${companyId}/configuration/admin/users/${userIdToUpdate}`, body);
}
